export { default } from "ember-element-helper/helpers/element";
